export const HOME_URL =
  process.env.REACT_APP_HOME_URL ?? 'http://localhost:3000';
export const API_URL =
  process.env.REACT_APP_API_URL ?? 'http://localhost:8000/v1';
